import { useEffect, useState } from 'react';
import { useAuth, loadImpSession, impSessionExpiresAt, clearImpSession } from '../auth';
import { useI18n } from '../i18n';

// 支持后台模拟登录模式的顶部横幅:标识当前"客服视角"的店铺与令牌有效期,
// 并提供退出。普通商家永远不会看到它 —— 只有从支持后台带着 imp_token 进来
// 的会话才渲染。文案跟随 admin 语言设置(原先硬编码中文)。
export default function SupportViewBanner() {
  const { shopDomain } = useAuth();
  const { t } = useI18n();
  const [session] = useState(loadImpSession);
  const expiresAt = session ? impSessionExpiresAt(session) : null;

  // 每分钟刷新一次,让"已过期"状态在页面开着不动时也能出现。
  const [, setTick] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setTick((t) => t + 1), 60_000);
    return () => clearInterval(timer);
  }, []);

  const expired = expiresAt != null && Date.now() >= expiresAt;
  const exit = () => {
    clearImpSession();
    window.location.href = '/';
  };

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        flexWrap: 'wrap',
        padding: '8px 16px',
        background: expired ? '#8e0b21' : '#1a7a5e',
        color: '#fff',
        fontSize: 13
      }}
    >
      <strong>{t('support.badge')}</strong>
      <span>{shopDomain || t('support.shopUnknown')}</span>
      <span style={{ opacity: 0.85 }}>
        {expired
          ? t('support.expired')
          : expiresAt
            ? t('support.validUntil', { time: new Date(expiresAt).toLocaleTimeString() })
            : null}
      </span>
      <button
        type="button"
        onClick={exit}
        style={{
          font: 'inherit',
          fontSize: 12,
          padding: '2px 12px',
          borderRadius: 6,
          border: '1px solid rgba(255,255,255,.6)',
          background: 'transparent',
          color: '#fff',
          cursor: 'pointer'
        }}
      >
        {t('support.exit')}
      </button>
    </div>
  );
}
